"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const React = __importStar(require("react"));
const clsx_1 = require("clsx");
const react_1 = require("@floating-ui/react");
const react_2 = require("react");
const Tooltip = (_a) => {
    var { className, children, closeLabel, description, displayTrigger, id, hoverDelay = 0, hoverTimeout = 100, onHintClose, placement, type = 'hint', visible, wrapperClassName } = _a, otherProps = __rest(_a, ["className", "children", "closeLabel", "description", "displayTrigger", "id", "hoverDelay", "hoverTimeout", "onHintClose", "placement", "type", "visible", "wrapperClassName"]);
    const arrowRef = React.useRef(null);
    const [isOpen, setIsOpen] = (0, react_2.useState)(visible);
    React.useEffect(() => {
        setIsOpen(visible);
    }, [visible]);
    const { refs, floatingStyles, context } = (0, react_1.useFloating)({
        middleware: [
            (0, react_1.arrow)({
                element: arrowRef,
            }),
            (0, react_1.flip)(),
            (0, react_1.offset)(type === 'hint' ? 15 : 9),
        ],
        open: isOpen,
        onOpenChange: setIsOpen,
        placement: placement !== null && placement !== void 0 ? placement : 'top',
        whileElementsMounted: react_1.autoUpdate,
    });
    const dismiss = (0, react_1.useDismiss)(context, {
        enabled: displayTrigger === 'click',
    });
    const hover = (0, react_1.useHover)(context, {
        delay: {
            close: hoverTimeout,
            open: hoverDelay,
        },
        enabled: displayTrigger === 'hover'
    });
    const { getReferenceProps, getFloatingProps } = (0, react_1.useInteractions)([
        dismiss,
        hover,
    ]);
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, clsx_1.clsx)('tk-tooltip__wrapper', wrapperClassName), onClick: () => {
                    displayTrigger === 'click' && setIsOpen(!isOpen);
                }, ref: refs.setReference }, getReferenceProps(), { children: children })), isOpen && (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, clsx_1.clsx)(`${type === 'tooltip' ? 'tk-tooltip' : 'tk-hint'}`, className), id: id, role: "tooltip", ref: refs.setFloating, style: floatingStyles }, otherProps, getFloatingProps(), { children: [(0, jsx_runtime_1.jsx)("span", { className: "tk-hint__description", children: description }), type === 'hint' && (0, jsx_runtime_1.jsx)("div", { className: "tk-hint__footer", children: closeLabel ? ((0, jsx_runtime_1.jsx)("span", { className: "tk-hint__close", onClick: () => {
                                setIsOpen(false);
                                onHintClose && onHintClose();
                            }, onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    onHintClose && onHintClose();
                                    setIsOpen(false);
                                }
                            }, tabIndex: 0, children: closeLabel })) : null }), type === 'hint' && (0, jsx_runtime_1.jsx)(react_1.FloatingArrow, { context: context, fill: "#2b2d32", ref: arrowRef })] }))] });
};
exports.Tooltip = Tooltip;
